module.exports = __webpack_public_path__ + "static/media/Artboard5.91ac68a3.png";